// import React, { useState, useEffect } from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import { useGetUserQuery } from "../../store/auth/usersApiSlice";
// import { setUserInfo, clearUserInfo } from "../../store/auth/authSlice";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { LoadingIcon, Modal, SessionExpired } from "../../components/common";

// const RootLayoutAdmin = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate()
//   const { userInfo, token } = useSelector((state) => state.auth);
//   const { data, isLoading, isSuccess, isError, error, refetch } = useGetUserQuery(token, {
//     skip: !token,
//     refetchOnMount: true,
//   });
//   useEffect(() => {
//     if (!userInfo && token) {
//       refetch();
//     }else if(!userInfo){
//       navigate('/login')
//     }
//   }, []);
//   const [isSessionExpired, setSessionExpired] = useState(false);

//   const sessionExpiredPopup = () => {
//     setSessionExpired(!isSessionExpired);
//     dispatch(clearUserInfo());
//     navigate("/login");
//   };
//   useEffect(() => {
//     if (isError) {
//       if (error?.data?.code == 'token_not_valid') {
//         setSessionExpired(true);
//       }
//     }
//     if (isSuccess) {
//       dispatch(setUserInfo({ ...data }));
//     }
//   }, [data, isError]);

//   if (isLoading)
//     return (
//       <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
//         <LoadingIcon />
//       </div>
//     );

//   return (
//     <>
//       {(isSessionExpired || isError) && <Modal modalHandle={sessionExpiredPopup}>
//         <SessionExpired handleNavigate={sessionExpiredPopup} />
//       </Modal>}
//       {isSuccess && (
//         <div className="flex h-screen overflow-hidden bg-slate max-w-[1920px] mx-auto">
//           <Sidebar />
//           <div className="w-full max-w-9xl mx-auto py-4 px-4 overflow-auto">
//             <Outlet />
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default RootLayoutAdmin;


import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useGetUserQuery } from "../../store/auth/usersApiSlice";
import { setUserInfo, clearUserInfo } from "../../store/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoadingIcon, Modal, SessionExpired } from "../../components/common";
import AdminNavbar from "../../components/common/AdminNavbar";

const RootLayoutAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo, token } = useSelector((state) => state.auth);
  const { data, isLoading, isSuccess, isError, error, refetch } =
    useGetUserQuery(token, {
      skip: !token,
      refetchOnMount: true,
    });
  
  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, []);

  const [isSessionExpired, setSessionExpired] = useState(false);

  const sessionExpiredPopup = () => {
    setSessionExpired(!isSessionExpired);
    dispatch(clearUserInfo());
    navigate("/login");
  };

  useEffect(() => {
    if (isError) {
      if (error?.data?.code === "token_not_valid") setSessionExpired(true);
    }
    if (isSuccess) {
      dispatch(setUserInfo({ ...data }));
    }
  }, [data, isError]);

  if (isLoading)
    return (
      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <LoadingIcon />
      </div>
    );

  return (
    <>
      {(isSessionExpired || isError) && (
        <Modal modalHandle={sessionExpiredPopup}>
          <SessionExpired handleNavigate={sessionExpiredPopup} />
        </Modal>
      )}

      {isSuccess && (
        <div className="flex h-screen overflow-hidden max-w-[1920px] mx-auto">

          {/* 🟦 LEFT SIDEBAR (NO CHANGES) */}
          <Sidebar />

          {/* 🟩 RIGHT SIDE CONTENT → NAVBAR + OUTLET */}
          <div className="flex bg-slate flex-col w-full max-w-9xl overflow-auto">

            {/* ⭐ ADD YOUR NAVBAR HERE ⭐ */}
            <AdminNavbar />

            {/* PAGE CONTENT */}
            <div className="py-4 px-4">
              <Outlet />
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default RootLayoutAdmin;

